<nav
  class="milinco-mobile-dock"
  [class.milinco-mobile-dock--workshop]="isWorkshop()"
  [attr.aria-label]="'shell.dock.navLabel' | translate"
>
  @if (isWorkshop()) {
    <div class="milinco-mobile-dock__workshop" role="tablist">
      <div
        class="milinco-mobile-dock__sections-wrap"
        [class.milinco-mobile-dock__sections-wrap--overflow]="sectionsOverflow()"
      >
        @if (canScrollLeft()) {
          <button
            type="button"
            class="milinco-mobile-dock__scroll-hint milinco-mobile-dock__scroll-hint--prev"
            (click)="scrollSections(-1)"
            [attr.aria-label]="'shell.dock.scrollPrev' | translate"
          >
            <span class="iconify" data-icon="solar:alt-arrow-left-linear" aria-hidden="true"></span>
          </button>
        }
        <div
          #sectionsEl
          class="milinco-mobile-dock__sections"
          (scroll)="onSectionsScroll()"
        >
          @for (link of workshopLinks(); track link.route) {
            <a
              class="milinco-mobile-dock__slot milinco-mobile-dock__section"
              [class.milinco-mobile-dock__slot--mesa-context]="showMesaContextOnLink(link.route)"
              [routerLink]="link.route"
              routerLinkActive="milinco-mobile-dock__slot--active"
              [routerLinkActiveOptions]="{ exact: link.route === '/starter' }"
              #rla="routerLinkActive"
              role="tab"
              [attr.title]="
                showMesaContextOnLink(link.route)
                  ? ('shell.dock.mesaContextHint' | translate)
                  : null
              "
            >
              <span class="milinco-mobile-dock__slot-icon-wrap">
                <app-nav-icon-pair
                  [icon]="link.iconName"
                  [active]="rla.isActive || showMesaContextOnLink(link.route)"
                  iconClass="milinco-mobile-dock__slot-icon"
                />
                @if (showMesaContextOnLink(link.route)) {
                  <span class="milinco-mobile-dock__slot-dot" aria-hidden="true"></span>
                }
              </span>
              <span class="milinco-mobile-dock__slot-label">{{ link.label | translate }}</span>
            </a>
          }
        </div>
        @if (canScrollRight()) {
          <button
            type="button"
            class="milinco-mobile-dock__scroll-hint milinco-mobile-dock__scroll-hint--next"
            (click)="scrollSections(1)"
            [attr.aria-label]="'shell.dock.scrollNext' | translate"
          >
            <span class="iconify" data-icon="solar:alt-arrow-right-linear" aria-hidden="true"></span>
          </button>
        }
      </div>
      @if (showDockMenu()) {
        <button
          type="button"
          class="milinco-mobile-dock__slot milinco-mobile-dock__slot--menu"
          (click)="openMore()"
          [attr.aria-label]="'shell.dock.more' | translate"
        >
          <span
            class="milinco-mobile-dock__slot-icon iconify"
            data-icon="solar:hamburger-menu-line-duotone"
            aria-hidden="true"
          ></span>
          <span class="milinco-mobile-dock__slot-label">{{ 'shell.dock.more' | translate }}</span>
        </button>
      }
    </div>
  } @else {
    <div
      class="milinco-mobile-dock__hub"
      [style.grid-template-columns]="'repeat(' + hubColumnCount() + ', minmax(0, 1fr))'"
    >
      @for (item of hubSlots(); track item.id) {
        <button
          type="button"
          class="milinco-mobile-dock__slot"
          [class.milinco-mobile-dock__slot--active]="isHubActive(item)"
          (click)="selectHub(item)"
        >
          <app-nav-icon-pair
            [icon]="item.iconName"
            [active]="isHubActive(item)"
            iconClass="milinco-mobile-dock__slot-icon"
          />
          <span class="milinco-mobile-dock__slot-label">{{ item.title | translate }}</span>
        </button>
      }
      @if (showDockMenu()) {
        <button
          type="button"
          class="milinco-mobile-dock__slot milinco-mobile-dock__slot--menu"
          (click)="openMore()"
        >
          <span
            class="milinco-mobile-dock__slot-icon iconify"
            data-icon="solar:hamburger-menu-line-duotone"
            aria-hidden="true"
          ></span>
          <span class="milinco-mobile-dock__slot-label">{{ 'shell.dock.more' | translate }}</span>
        </button>
      }
    </div>
  }
</nav>
